import styled from "@emotion/native";
import { Animated, ViewStyle, TextStyle } from "react-native";
import Text from "../Text";

export const EMOJI_WIDTH = 45;
export const EMOJI_TRANSLATE_X_MARGIN = 16;

const SELECTOR_MARGIN_VERTICAL = 20;
const RESPONSE_TITLE_MARGIN_BOTTOM = 22;

export const Container = styled.View({});

export const Prompt = styled(Animated.View)({});

// @ts-ignore
export const PromptTitle = styled(Text)({
    maxWidth: "60%",
    paddingHorizontal: 12,
    lineHeight: "30px",
    // fontSize: 20,
    // letterSpacing: 0,
    // flex: 1,
});

export const Selector = styled.View(
    {
        height: EMOJI_WIDTH,
        marginVertical: SELECTOR_MARGIN_VERTICAL,
        paddingHorizontal: 32,
        flexDirection: "row",
        justifyContent: "space-between",
        zIndex: 2,
    },
    ({ theme }: any) => {
        let style: ViewStyle = {};

        if (theme.verticalScale < 1) {
            const height = EMOJI_WIDTH * theme.verticalScale;
            const marginVertical =
                SELECTOR_MARGIN_VERTICAL * theme.verticalScale;

            style = {
                height,
                marginVertical,
            };
        }

        return style;
    },
);

export const Response = styled(Animated.View)({
    position: "absolute",
    alignItems: "flex-start",
    paddingHorizontal: 12,
});

export const ResponseTitle = styled(Text)(
    {
        marginBottom: RESPONSE_TITLE_MARGIN_BOTTOM,
        marginTop: 15,
        minWidth: 120,
    },
    ({ theme }: any) => {
        let style: TextStyle = {};

        if (theme.verticalScale < 1) {
            const marginBottom =
                RESPONSE_TITLE_MARGIN_BOTTOM * theme.verticalScale;

            style = {
                marginBottom,
            };
        }

        return style;
    },
);

export const RedoContainer = styled.View(
    {
        position: "absolute",
        left: 0,
        top: 9,
        width: 64,
        height: 24,
    },
    ({ responseTitleFrame }: any) => {
        const style: ViewStyle = {};
        const MARGIN_LEFT = 12;

        if (responseTitleFrame) {
            style.top = (responseTitleFrame.height - 24) / 2 + 15;
            style.left =
                responseTitleFrame.x +
                responseTitleFrame.width +
                EMOJI_WIDTH +
                EMOJI_TRANSLATE_X_MARGIN +
                MARGIN_LEFT;
        }

        return style;
    },
);
